import $ from 'jquery';

export default () => {
    $('.has-repeatable').each(function(k,v) {
        var $me = $(v),
            $repeat = $me.find('.is-repeatable').first(),
            $trigger = $me.find('.repeatable__repeat'),
            $clone,
            i = 0,
            clearforms = $me.data('clear-forms') || false,
            max = $me.data('repeat-max') || false;

        $me.on('click', '.repeatable__repeat', function(ev) {
            ev.preventDefault();

            $trigger.blur();

            if (max === false || $me.find('.is-repeatable').length < max) {
                $trigger.show();
                $clone = $repeat.clone();
                i++;

                $clone
                    .find('[for$="-0"]').attr('for', function() { return $(this).attr('for').replace('-0', '-' + i); })
                .end()
                    .find('[id$="-0"]').attr('id', function() { return $(this).attr('id').replace('-0', '-' + i); })
                .end()
                    .appendTo($me);

                if (clearforms)
                    $clone.find('input[type="text"], input[type="email"]').val('');

                if (!! max && $me.find('.is-repeatable').length >= max) {
                    $trigger.hide();
                }
            }
        });
    });
}
